var _rect, _rect2, _rect3, _rect4, _rect5, _rect6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTicketStitch2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 372,
    height: 7,
    viewBox: "0 0 372 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 57,
    height: 7,
    rx: 3.5,
    fill: "#E6E7E9"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 65,
    width: 54,
    height: 7,
    rx: 3.5,
    fill: "#E6E7E9"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 126,
    width: 56,
    height: 7,
    rx: 3.5,
    fill: "#E6E7E9"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 190,
    width: 56,
    height: 7,
    rx: 3.5,
    fill: "#E6E7E9"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 253,
    width: 54,
    height: 7,
    rx: 3.5,
    fill: "#E6E7E9"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 315,
    width: 57,
    height: 7,
    rx: 3.5,
    fill: "#E6E7E9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicketStitch2);
export default __webpack_public_path__ + "static/media/TicketStitch2.f76ab1a9cf31e6d6f8b30079070fc3af.svg";
export { ForwardRef as ReactComponent };